import { createContext } from "react";

// True inside a Map's `topRightControls`. An icon action there is a cell in
// one of Mapbox's control groups, so it takes their shape instead of its own
// compact one: it fills the cell, centres a full-size icon and uses the dark
// glyph colour Mapbox draws on its white groups in either theme.
export const MapControlContext = createContext(false);
